import {Action} from "redux";
import {compose, Dispatcher} from "../utils";
import {CategoryManagerAction, CategoryManagerActionWrapper} from "./actions";
import {CategoryManagerCallbackProps, CategoryManagerValueProps} from "./presentation";
import {CategoryTreeItem} from "./data";
import {CategoryManagerState} from "./reducers";

export type CategoryManagerOwnProps = {
	categories: CategoryTreeItem[]
}

export const categoryManagerMapStateToProps = (state: CategoryManagerState, ownProps: CategoryManagerOwnProps): CategoryManagerValueProps => ({
	...state,
	categories: ownProps.categories
})

export const categoryManagerMapDispatchToProps = <ClientState>(dispatch: Dispatcher<Action, ClientState>): CategoryManagerCallbackProps => {
	const wrap = (action: CategoryManagerAction): CategoryManagerActionWrapper => ({
		type: "category manager action",
		action
	})
	const dispatchAction = compose(wrap, dispatch)
	return {
		setCategoryCheckbox: (value) => dispatchAction({type: "set category checkbox", value}),
		unsetCategoryCheckbox: (value) => dispatchAction({type: "unset category checkbox", value}),
	}
}



// WEBPACK FOOTER //
// ./src/lib/category-manager/app.ts